export default __webpack_public_path__ + "static/media/likes.9cf5681e.svg";